var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpholsteryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Couch",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 42,
    viewBox: "0 0 58 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M32,12a98.418,98.418,0,0,0-13.387.8A9.991,9.991,0,0,0,10,22.7V41H54V22.7a9.991,9.991,0,0,0-8.613-9.9A98.418,98.418,0,0,0,32,12Z",
    transform: "translate(-3 -11)",
    fill: "#f44040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M48,46h4v6H48ZM16,52H12V46h4Z",
    transform: "translate(-3 -11)",
    fill: "#072e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M60,29a5,5,0,0,0-5.491-4.976A5.144,5.144,0,0,0,50,29.214V38H14V29.215a5.145,5.145,0,0,0-4.509-5.191A5,5,0,0,0,8,33.9V42a2,2,0,0,0,2,2H54a2,2,0,0,0,2-2V33.9A5,5,0,0,0,60,29Z",
    transform: "translate(-3 -11)",
    fill: "#b3001b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M10,44H54v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2Z",
    transform: "translate(-3 -11)",
    fill: "#910016"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M16,34H30a2,2,0,0,1,2,2v2H14V36A2,2,0,0,1,16,34Z",
    transform: "translate(-3 -11)",
    fill: "#bfd9ea"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M50,38H32V36a2,2,0,0,1,2-2H48a2,2,0,0,1,2,2Z",
    transform: "translate(-3 -11)",
    fill: "#e2eff7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M59.035,24.56A6.007,6.007,0,0,0,55,23v-.3a11.037,11.037,0,0,0-9.477-10.9A100.081,100.081,0,0,0,32,11a100.108,100.108,0,0,0-13.524.805A11.037,11.037,0,0,0,9,22.7V23A6,6,0,0,0,7,34.657V42a3,3,0,0,0,2,2.816V46a3,3,0,0,0,2,2.816V52a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V49H47v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V48.816A3,3,0,0,0,55,46V44.816A3,3,0,0,0,57,42V34.657a6,6,0,0,0,2.035-10.1ZM18.75,13.785A98.568,98.568,0,0,1,32,13a98.568,98.568,0,0,1,13.25.785A9.03,9.03,0,0,1,53,22.7v.657a6.25,6.25,0,0,0-4,5.857v3.97A2.964,2.964,0,0,0,48,33H34a2.976,2.976,0,0,0-2,.78A2.977,2.977,0,0,0,30,33H16a2.966,2.966,0,0,0-1,.184v-3.97a6.25,6.25,0,0,0-4-5.856V22.7a9.032,9.032,0,0,1,7.75-8.916ZM15,37V36a1,1,0,0,1,1-1H30a1,1,0,0,1,1,1v1Zm18-1a1,1,0,0,1,1-1H48a1,1,0,0,1,1,1v1H33ZM15,51H13V49h2Zm36,0H49V49h2Zm2-5a1,1,0,0,1-1,1H12a1,1,0,0,1-1-1V45H53Zm2.8-13.08a1,1,0,0,0-.8.98V42a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V33.9a1,1,0,0,0-.8-.98,4,4,0,0,1-1.89-6.88A3.958,3.958,0,0,1,9,25c.132,0,.266.006.4.019a4.149,4.149,0,0,1,3.6,4.2V38a1,1,0,0,0,1,1H50a1,1,0,0,0,1-1V29.215a4.149,4.149,0,0,1,3.6-4.2,4,4,0,0,1,1.2,7.9Z",
    transform: "translate(-3 -11)",
    fill: "#02245a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M38,23h1v1a1,1,0,0,0,2,0V23h1a1,1,0,0,0,0-2H41V20a1,1,0,0,0-2,0v1H38a1,1,0,0,0,0,2ZM22,23h1v1a1,1,0,0,0,2,0V23h1a1,1,0,0,0,0-2H25V20a1,1,0,0,0-2,0v1H22a1,1,0,0,0,0,2Z",
    transform: "translate(-3 -11)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpholsteryIcon);
export default __webpack_public_path__ + "static/media/upholsteryIcon.38722b1d0a39413adea447978554d16b.svg";
export { ForwardRef as ReactComponent };